import {Component, Prop, Vue, Emit} from 'vue-property-decorator';
import Service from '../../../../common/src/assets/service/service';
import Common from '../../../../common/src/assets/js/common';

@Component
export default class AuthenticationInfo extends Vue {
    private $platform: any;
    private $router: any;
    private userID: string = '';
    private userInfo: any = {};         // 用户基础信息
    private resourceList: any = [
        {title: '云服务器', content: '极速、稳定、高弹性的计算服务', link: '/resource/vm/create', img: 'general-resource-vm.png'},
        {title: '云磁盘', content: '高度灵活按需调整的存储设备', link: '/resource/disk/list', img: 'general-resource-disk.png'},
        {title: '云快照备份', content: '快捷方便的恢复与备份功能', link: '/resource/snap/list', img: 'general-resource-snap.png'},
        {title: '弹性公网IP', content: '灵活独立的公网资源', link: '/resource/ip/list', img: 'general-resource-ip.png'},
        {title: 'VPC虚拟私有云', content: '安全隔离的网络', link: '/resource/vpc/list', img: 'general-resource-vpc.png'},
        {title: 'NAT网关', content: 'VPC架构的公网流量出入口，灵活定义规则', link: '/resource/nat/list', img: 'general-resource-nat.png'},
        {title: 'SLB负载均衡', content: '对多台云服务器进行流量分发服务', link: '/resource/slb/create', img: 'general-resource-slb.png'},
        // {title: 'RDS云数据库', content: '专业、高性能、高可靠、安全的云数据库服务', link: '/resource/rds/create', img: 'general-resource-rds.png'},
    ]

    private status: any = {
        loading: '',
        type: 'person'
    }

    private created() {
        this.userID = Common.getUserID(this.$platform);
        this.getUserInfo();
    }

        /**获取用户信息 */
    private getUserInfo() {
        let params = {
            userID: this.userID,
        };
        Service.request('/user/queryCustomerInfo', params, 'token')
            .then((res: any) => {
                let data = res.data;
                this.userInfo = data;

                if (this.userInfo.companyVeriyed === 1) {
                    this.status.type = 'company';
                } else if (this.userInfo.personVeriyed === 1){
                    this.status.type = 'person';
                } else {
                    this.status.type = 'none';
                }

            })
            .catch(error => {
            });
    }

    private skip(url: string){ 
        this.$router.push(url)
    }
}